import { ApplicationTypes, attachAdminComponent } from 'element-domain'

import { createAdminPagesFromSpec } from '@salsita-ai/platform-project-sdk/admin'
import { adminSidebarComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain'

import { configuratorInterface } from '../systems/configurator-interface'
import { PricingActionsElement } from './ui/PricingActionsElement'
import { PricingPageElement } from './ui/PricingPageElement'
import { PricingSidebarElement } from './ui/PricingSidebarElement'

const { components: commonComponents } = createAdminPagesFromSpec(
  ApplicationTypes.$adminPagesSpec,
  ApplicationTypes.$dataSpec
)

export const adminElements = [
  configuratorInterface.createCustomPhoenixLayoutElement('PricingPage', PricingPageElement),
  configuratorInterface.createCustomPhoenixLayoutElement('PricingActions', PricingActionsElement),
]

export const adminComponents = [
  ...commonComponents,
  attachAdminComponent
    .withEntity('PricingSettings')
    .withComponent(adminSidebarComponent, 'pricing-settings-sidebar')
    .withGradualFilter({
      navigationStates: [ApplicationTypes.AdminNavigationState.Pricing],
      selectedEntityIds: s => [s.id],
    })
    .attach(
      memoEval(
        s => [s.id, s.$admin.id],
        (id, adminId) => {
          return {
            title: 'Edit Recipe',
            page: <PricingSidebarElement entityId={id} />,
            fallbackId: adminId,
          }
        }
      )
    ),
]
